import cn from 'classnames';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './AISummaryButton.module.scss';

interface AISummaryButtonProps {
  triggerAiSummaryGeneration: () => void;
  disabled: boolean;
  isSummaryLoading: boolean;
  isCampaignCompleted: boolean;
}

function determineToolTipText(isSummaryLoading: boolean, isCampaignCompleted: boolean) {
  if (isSummaryLoading) {
    return 'page.campaignDetails.performanceTab.aiSummaryButtonTooltipIsGenerating';
  }

  if (isCampaignCompleted) {
    return 'page.campaignDetails.performanceTab.aiSummaryButtonTooltipCampaignCompleted';
  }

  return 'page.campaignDetails.performanceTab.aiSummaryButtonTooltipCampaignNotCompleted';
}

export function AISummaryButton({
  triggerAiSummaryGeneration,
  disabled,
  isSummaryLoading,
  isCampaignCompleted,
}: AISummaryButtonProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  const translationKey = determineToolTipText(isSummaryLoading, isCampaignCompleted);
  const toolTipText = disabled ? translationKey : '';

  return (
    <Button
      type='button'
      className={cn(styles.button)}
      unstyled
      onClick={triggerAiSummaryGeneration}
      disabled={disabled}
      tooltip={t(toolTipText)}
      tooltipOptions={{
        showOnDisabled: disabled,
        position: 'top',
        at: 'center top-10',
        style: { textAlign: 'center' },
      }}
    >
      <span className={styles.text}>{t('page.campaignDetails.performanceTab.aiSummaryButtonText')}</span>
      <i className='pi pi-sparkles' />
    </Button>
  );
}
